import { all, call, put, takeLatest } from 'redux-saga/effects'

import { setErrorMessage, setSuccessMessage } from 'components/Windows/CentralMessagesList/reducer'
import { callApiAsync } from 'services/api/callAPIAsync'
import { setUser } from 'services/user/reducer'
import { convertStringToBoolean } from '../../../global/helpers'
import { contactInfo, gdprAgreements, uploadImage } from './reducer'

function* contactInfoCallSaga({ payload }) {
    const { data, error } = yield call(callApiAsync, 'register', { ...payload })
    if (error) {
        yield put(setErrorMessage(error))
        console.error(error)
        return
    }
    yield put(setSuccessMessage('CONTACT_INFO_CHANGE'))
    yield put(setUser(data))
}

function* uploadProfileImageSaga({ payload }) {
    const { data, error } = yield call(callApiAsync, 'uploadProfileImage', {
        file_extension: 'png',
        content: payload.blob,
    })
    if (error) {
        yield put(setErrorMessage(error))
        console.error(error)
        return
    }
    const imageId = new Date().valueOf()
    yield put(setUser({ ...data, imageId }))
    yield put(setSuccessMessage('IMAGE_UPLOAD'))
}

function* gdprAgreementsCallSaga({ payload }) {
    const personal = convertStringToBoolean(payload?.personal)
    const non_personal = convertStringToBoolean(payload?.nonPersonal)

    const { data, error } = yield call(callApiAsync, 'gdprSet', { personal, non_personal })
    if (error) {
        yield put(setErrorMessage(error))
        console.error(error)
        return
    }
    yield put(setSuccessMessage('GDPR_CHANGE'))
    yield put(setUser(data))
}

export default function* contactInfoSaga() {
    yield all([
        takeLatest(contactInfo.type, contactInfoCallSaga),
        takeLatest(gdprAgreements.type, gdprAgreementsCallSaga),
        takeLatest(uploadImage.type, uploadProfileImageSaga),
    ])
}
